// Keep in sync with $mobile-max in scss/_variables.scss.
// Mobile layout applies for viewport widths up to and including MOBILE_MAX_WIDTH.
export const MOBILE_MAX_WIDTH = 991;

export const isMobileViewport = (): boolean => window.innerWidth <= MOBILE_MAX_WIDTH;
